export default "__VITE_ASSET__DXNHkYtJ__"